var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF7D6B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.643 2.344C6.93 2.267 2.268 6.93 2.345 12.642 2.42 18.12 6.88 22.58 12.359 22.656c5.713.078 10.375-4.585 10.297-10.297-.075-5.479-4.535-9.94-10.013-10.015zm6.172 15.979a.194.194 0 01-.235.04.195.195 0 01-.064-.056 6.07 6.07 0 00-1.58-1.445c-1.243-.798-2.818-1.237-4.435-1.237-1.617 0-3.192.44-4.435 1.237a6.065 6.065 0 00-1.58 1.445.196.196 0 01-.3.015 8.56 8.56 0 01-2.279-5.675c-.08-4.752 3.82-8.73 8.573-8.74 4.753-.013 8.615 3.847 8.615 8.593a8.56 8.56 0 01-2.28 5.823z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.031c-.963 0-1.834.361-2.453 1.017-.618.656-.927 1.562-.858 2.536.142 1.916 1.627 3.479 3.31 3.479 1.684 0 3.166-1.563 3.31-3.479.073-.964-.234-1.862-.863-2.53-.62-.66-1.49-1.023-2.447-1.023z"
  }))));
}
export default SvgPersonCircleOutline;